// Module
var code = "<div class=\"fg-field-inner\"> <div class=\"col s12 l12\"> <p>{{:: fieldSchema.displayName }}</p> </div> </div> ";
// Exports
export default code;